import React from 'react';

import ConnectedAuthNotification from '../../connectedComponents/AuthNotification';

import './SplitContainer.scss';

const SplitContainer = ({ children }) => (
    <div className="split-container">
        <ConnectedAuthNotification />

        <div className="split-container__left">
            <div className="split-container__content">{children}</div>
        </div>

        <div className="split-container__right" />
    </div>
);

export default SplitContainer;
